import React from 'react'
import PropTypes from 'prop-types'
import {
  Segment,
  Container,
  Grid,
  Icon
} from 'semantic-ui-react'
import { Zoom } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'

const propTypes = {
  pageData: PropTypes.object.isRequired
}
const images = ['/img/carousel/header1.jpg', '/img/carousel/header2.jpg', '/img/carousel/header3.jpg',
  '/img/carousel/header4.jpg', '/img/carousel/header5.jpg', '/img/carousel/header6.jpg',
  '/img/carousel/header7.jpg', '/img/carousel/header8.jpg', '/img/carousel/header9.jpg',
  '/img/carousel/header10.jpg', '/img/carousel/header11.jpg', '/img/carousel/header12.jpg',
  '/img/carousel/header13.jpg', '/img/carousel/header14.jpg', '/img/carousel/header15.jpg',
  '/img/carousel/header16.jpg', '/img/carousel/header17.jpg', '/img/carousel/header18.jpg',
  '/img/carousel/header19.jpg', '/img/carousel/header20.jpg', '/img/carousel/header21.jpg']
const zoomOutProperties = {
  duration: 2000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  scale: 0.4,
  arrows: true
}
const Ponudba = () => (
  <Segment basic>
    <Container>
      <Zoom {...zoomOutProperties}>
        {
          images.map((each, index) => <img key={index} style={{ width: '100%' }} alt="Slikopleskarstvo in suhomontaža Cvetek" src={each} />)
        }
      </Zoom>
      <h3 id="category-title">Storitve</h3>
      <Grid columns="three" stackable divided padded>
        <Grid.Row style={{ marginBottom: 5 }}>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" />
              PRIPOROČEN IZVAJALEC vgradnje strešnih oken Velux
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Montaža in vzdrževanje strešnih oken in senčil
            </h4>
          </Grid.Column>

          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Pleskarska dela
            </h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ marginBottom: 5 }}>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" />
              Fasaderska in štukaterska dela
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Suhomontažne obloge, stropi in predelne stene po sistemu Knauf
            </h4>
          </Grid.Column>

          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Izdelava armstrong stropa
            </h4>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ marginBottom: 5 }}>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" />
              Izsuševanje in ogrevanje prostorov
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Izdelava napuščev
            </h4>
          </Grid.Column>

          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Montaža svetlobnikov
            </h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ marginBottom: 5 }}>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" />
              Izdelovanje podstrešnih stanovanj
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Vpihovanje celulozne izolacije
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Polaganje PVC talnih oblog Karndean (Lightline, Conceptline, Projectline in Freeline)
            </h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ marginBottom: 5 }}>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" />
              Razvlaževanje prostorov
            </h4>
          </Grid.Column>
          <Grid.Column>
            <h4 id="article-title">
              <Icon name="asexual" color="black" size="large" /> Izposoja razvlažilcev prostorov
            </h4>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
)

Ponudba.propTypes = propTypes
export default Ponudba



// WEBPACK FOOTER //
// ./src/pages/storitve/Storitve.js